module.exports = __webpack_public_path__ + "img/header_pens.fd027dea.jpg";